/** Default min-height (px) for the form container and its loading skeleton. Single source of truth shared by the Builder input default, the Form component, and the skeleton placeholder. */
export const DEFAULT_FORM_HEIGHT = 364;
